import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import PropTypes from 'prop-types'

import Email from '../../shared/Email'
import FormWrapper from '../../shared/FormWrapper'
import Input from '../../shared/Input'

const ContactForm = props => {
  const methods = useForm()
  const {errors} = methods.formState

  return (
    <Stack className='contact-form'>
      <FormWrapper methods={methods} handleSubmit={props.handleSubmit}>
        <Input
          error={!!errors.firstName}
          label='First Name'
          name='firstName'
          options={{required: 'First Name is required'}}
          helperText={errors.firstName?.message}
          margin='dense'
        />
        <Input
          error={!!errors.lastName}
          label='Last Name'
          name='lastName'
          options={{required: 'Last Name is required'}}
          helperText={errors.lastName?.message}
          margin='dense'
        />
        <Email
          error={!!errors.email}
          helperText={errors.email?.message || "We'll email an invitation to this address when you send it. Use one they check."}
        />
        <Button
          disabled={props.loading}
          type='submit'
          variant='contained'
          sx={{color: '#F7F7F7'}}>
          Add contact
        </Button>
      </FormWrapper>
    </Stack>
  )
}

ContactForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default ContactForm
